import {
  Panel,
  PanelSection,
  EmptyState,
  EmptyStateTitle,
  EmptyStateDescription,
} from '@customerio/pluma-components/react';

export function CustomSMTPEmptyState() {
  return (
    <Panel>
      <PanelSection display="flex" justifyContent="center" alignItems="center" p="400">
        <EmptyState>
          <EmptyStateTitle icon="warning">Using Custom SMTP</EmptyStateTitle>
          <EmptyStateDescription>
            We can not provide deliverability metrics for custom SMTP servers.
          </EmptyStateDescription>
        </EmptyState>
      </PanelSection>
    </Panel>
  );
}
